/**
 * to number
 * @param  {number|string} n
 * @return {number}
 */
__.toNumber = function(n) {
  if (typeof n === 'string') n = parseInt(n);
  return n;
};
